// Shared config-tool constants used by both the rendering component
// (SelectedConfig.js) and the PDF generator (helpers/generator/modular/config-tool).

// Max number of rows the part-numbers table can hold.
export const MAX_TABLE_ELEMENTS = 17;
